module.exports = __webpack_public_path__ + "img/reconside.53dc4aae.svg";